export default __webpack_public_path__ + "static/media/m-serviceInfo3.2ca148b9.png";